import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIt = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 3 2",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 1,
			height: 2,
			fill: "#009246"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1,
			height: 2,
			x: 1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1,
			height: 2,
			x: 2,
			fill: "#ce2b37"
		})
	]
});
export default SvgIt;
